// pages/DeliveryTransactionsPage.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom'; // Assuming react-router
import { GetDeliveryBoysTransactionsData } from '../../../lib/data';
import AddTransactionForm from '../../../ui/deliveryBoysUi/AddTransactionForm';
import TransactionHistory from '../../../ui/deliveryBoysUi/TransactionHistory';
import WalletCard from '../../../ui/deliveryBoysUi/walletCard';

const DeliveryTransactionsPage = () => {
  // 1. Get ID from URL Params
  const { id } = useParams(); 
  
  // 2. State Management
  const [data, setData] = useState({ transactions: [], wallet_balance: "0" });
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  // 3. Fetch Data Function
  const fetchData = useCallback(async (pageNum = 1) => {
    setLoading(true);
    try {
      const response = await GetDeliveryBoysTransactionsData(id, pageNum);
      setData(response.data);
      setPagination(response.pagination);
      setPage(pageNum);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  // Initial Load
  useEffect(() => {
    if (id) fetchData(1);
  }, [id, fetchData]);

  return (
    <div className="min-h-screen bg-primary p-10 font-sans">
      <div className="max-w-7xl mx-auto space-y-6">
        
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <div>
            <h1 className="text-2xl font-bold text-white">Delivery Boy Wallet</h1>
            <p className="text-gray-500 text-sm mt-1">Manage finances and view transaction history for ID #{id}</p>
          </div>
          {/* Stats Card */}
          <div className="w-full md:w-1/3">
             <WalletCard balance={data.wallet_balance} />
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
          {/* Left Column: Transaction History (Takes up 2/3 width) */}
          <div className="lg:col-span-2">
            <TransactionHistory 
              transactions={data.transactions} 
              pagination={pagination}
              loading={loading}
              onPageChange={(newPage) => fetchData(newPage)}
            />
          </div>

          {/* Right Column: Add Form (Takes up 1/3 width) */}
          <div className="lg:col-span-1">
            <AddTransactionForm 
              deliveryBoyId={id} 
              onTransactionAdded={() => fetchData(1)} // Reset to page 1 on new add
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default DeliveryTransactionsPage;